import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { IncomingInvoicesTable } from "./tables/IncomingInvoices.table";

export function IncomingInvoicesPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <IncomingInvoicesTable />
        <Toast />
      </Dashboard>
    </ToastProvider>
  );
}
